import { APICurrentUser } from '@ardoq/api-types';
import { permissionsOperations } from '@ardoq/access-control';
import { I18nLocale, t } from '@ardoq/i18n';
import { isTourStartable } from '@ardoq/product-tours';
import { startTour } from '@ardoq/product-tours-host';
import { dispatchAction } from '@ardoq/rxbeach';
import { Text } from '@ardoq/typography';
import { isPresentationMode } from 'env';
import {
  EphemeralCornerNotificationContent,
  EphemeralNotificationRelevanceContext,
} from '../types';

export const getDataInventoryWhatsNewTourPromptContent = (
  i18nLocale: I18nLocale
): EphemeralCornerNotificationContent => ({
  position: 'bottom-left',
  cards: [
    {
      header: t(
        i18nLocale,
        'ephemeralNotification:dataInventoryWhatsNewTour.header',
        'Work faster in Data Inventory'
      ),
      content: null,
      bodyText: (
        <Text variant="text2">
          {t(
            i18nLocale,
            'ephemeralNotification:dataInventoryWhatsNewTour.bodyText',
            "We've made improvements to filters, reference copying, field groups, hierarchy expansion and opening components in a new tab."
          )}
        </Text>
      ),
    },
  ],
  endButtonLabel: t(
    i18nLocale,
    'ephemeralNotification:dataInventoryWhatsNewTour.startButton',
    "See what's new"
  ),
  showSkipButton: true,
  skipButtonLabel: t(
    i18nLocale,
    'ephemeralNotification:dataInventoryWhatsNewTour.dismissButton',
    'Not now'
  ),
  onActionButtonClick: () =>
    dispatchAction(startTour('data-inventory-whats-new-2026-10')),
});

export const isDataInventoryWhatsNewTourRelevantForCurrentUser = (
  currentUser: APICurrentUser,
  {
    featureContext,
    toursWithSatisfiedDataGates,
  }: EphemeralNotificationRelevanceContext
): boolean =>
  !isPresentationMode() &&
  isTourStartable('data-inventory-whats-new-2026-10', {
    featureContext,
    hasWriteAccess: permissionsOperations.isOrgWriter(currentUser),
    hostApp: 'ardoq-front',
    toursWithSatisfiedDataGates,
  });
